import { toast } from "sonner";

const isIOS = () => /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const inAppBrowser = () => isIOS() && !/Safari\//.test(navigator.userAgent);

// Immersions put iOS into "playback" (silent-switch proof); the mic needs the session handed back first.
export function releaseAudioSession() {
  try { if (navigator.audioSession) navigator.audioSession.type = "auto"; } catch {}
}

function helpFor(err) {
  if (err?.name === "NotFoundError") return { title: "No microphone found", steps: "Plug in or connect a microphone, then try again." };
  if (isIOS()) {
    return {
      title: "Your microphone is switched off for Xcelio",
      steps: inAppBrowser()
        ? "You're inside another app's browser. Tap the ↗ (open) button to open Xcelio in Safari, then allow the microphone when asked. Or go to iPhone Settings → that app → turn Microphone on."
        : "In Safari, tap the “aA” button in the address bar → Website Settings → Microphone → Allow. Or open iPhone Settings → Apps → Safari → Microphone → Allow. Then come back and try again.",
    };
  }
  return { title: "Your microphone is switched off for Xcelio", steps: "Tap the lock or settings icon beside the web address → Permissions → Microphone → Allow. Then try again." };
}

// getUserMedia with one retry after releasing the audio session, and clear guidance if it still fails.
export async function getMic(audio = true) {
  releaseAudioSession();
  try {
    return await navigator.mediaDevices.getUserMedia({ audio });
  } catch (e) {
    if (e?.name !== "NotAllowedError" && e?.name !== "NotFoundError") {
      await new Promise((r) => setTimeout(r, 400));
      try { return await navigator.mediaDevices.getUserMedia({ audio }); } catch (e2) { e = e2; }
    }
    const h = helpFor(e);
    toast.error(h.title, { description: h.steps, duration: 20000, id: "mic-help" });
    throw e;
  }
}
